import React, {useState} from 'react';
import {Button, ConfigProvider, Modal} from "antd";

const NotifyActionsOnRecordModal = ({
                                     showNotifyActionsOnRecordModal,
                                     setShowNotifyActionsOnRecordModal,
                                     modalText,
                                     modalTitle,
                                     handleAction,
                                 }) => {
    const [confirmLoading, setConfirmLoading] = useState(false);

    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
            handleAction();
            setShowNotifyActionsOnRecordModal(false);
            setConfirmLoading(false);
        }, 1000);
    };


    return (
        <Modal
            title={modalTitle}
            open={showNotifyActionsOnRecordModal}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={()=> {
                setShowNotifyActionsOnRecordModal(false);
            }}
            footer={[
                <Button
                    key="ok"
                    color="danger"
                    variant={"solid"}
                    onClick={handleOk}
                    loading={confirmLoading}
                >
                    Confirm
                </Button>,
                <ConfigProvider
                    theme={{
                        token: {
                            borderRadius: 2,
                            colorBorder: "transparent",
                            boxShadow: "0 0 #0000",
                            colorPrimaryText: "blue",
                        },
                    }}
                >
                    <Button
                        key="cancel"
                        className="text-medium-blue-100 shadow-md border-slate-600 rounded"
                        onClick={() => {
                            setShowNotifyActionsOnRecordModal(false);
                        }}
                    >
                        Cancel
                    </Button>
                </ConfigProvider>
            ]}
        >
            <p className="text-lg text-blue-900">
                {modalText}
            </p>
        </Modal>
    );
};

export default NotifyActionsOnRecordModal;